
  import React, { useState, useEffect , useRef} from 'react';
  import { useNavigate } from 'react-router-dom';

  import './styling/Home.css'; // Import your CSS file for styling
  import Slider from 'react-slick';
  import 'slick-carousel/slick/slick.css';
  import 'slick-carousel/slick/slick-theme.css';

  import HomepgSliders from './HomepgSliders';

// front slider
  import slider1_1 from './styling/images/home/slider1/1.jpg';
  import slider1_2 from './styling/images/home/slider1/2.jpg';
  import slider1_3 from './styling/images/home/slider1/3.jpg';
  import slider1_4 from './styling/images/home/slider1/4.jpg';
  import slider1_5 from './styling/images/home/slider1/5.jpg';

  // small image icons

  // slide 1 
  import head_img1 from './styling/images/home/slider1/head1.png';

  import smallimg1_1 from './styling/images/home/slider1/smallimgs/1/s1.png';
  import smallimg1_2 from './styling/images/home/slider1/smallimgs/1/s2.png';
  import smallimg1_3 from './styling/images/home/slider1/smallimgs/1/s3.png';
  import smallimg1_4 from './styling/images/home/slider1/smallimgs/1/s4.png';
  import smallimg1_5 from './styling/images/home/slider1/smallimgs/1/s5.png';
  import smallimg1_6 from './styling/images/home/slider1/smallimgs/1/s6.png';

// slide 2
  import head_img2 from './styling/images/home/slider1/head2.png';

  import smallimg2_1 from './styling/images/home/slider1/smallimgs/2/s1.png';
  import smallimg2_2 from './styling/images/home/slider1/smallimgs/2/s2.png';
  import smallimg2_3 from './styling/images/home/slider1/smallimgs/2/s3.png';
  import smallimg2_4 from './styling/images/home/slider1/smallimgs/2/s4.png';
  import smallimg2_5 from './styling/images/home/slider1/smallimgs/2/s5.png';
  import smallimg2_6 from './styling/images/home/slider1/smallimgs/2/s6.png';
  
  // slide 3
  
  import head_img3 from './styling/images/home/slider1/head3.png';
 
  import smallimg4_1 from './styling/images/home/slider1/smallimgs/3/s1.png';
  import smallimg4_2 from './styling/images/home/slider1/smallimgs/3/s2.png';
  import smallimg4_3 from './styling/images/home/slider1/smallimgs/3/s3.png';
  import smallimg4_4 from './styling/images/home/slider1/smallimgs/3/s4.png';
  import smallimg4_5 from './styling/images/home/slider1/smallimgs/3/s5.png';
  import smallimg4_6 from './styling/images/home/slider1/smallimgs/3/s6.png';
  
  
  // slide 4
  
  import head_img4 from './styling/images/home/slider1/head4.png';

  import smallimg5_1 from './styling/images/home/slider1/smallimgs/4/s1.png';
  import smallimg5_2 from './styling/images/home/slider1/smallimgs/4/s2.png';
  import smallimg5_3 from './styling/images/home/slider1/smallimgs/4/s3.png';
  import smallimg5_4 from './styling/images/home/slider1/smallimgs/4/s4.png';
  import smallimg5_5 from './styling/images/home/slider1/smallimgs/4/s5.png';
  import smallimg5_6 from './styling/images/home/slider1/smallimgs/4/s6.png';


  import logo from './styling/images/home/aros_logo.jpg';

  // products slide images
  import products_slide_1 from './styling/images/home/products_slides/product1_ups.png';
  import products_slide_2 from './styling/images/home/products_slides/product2_stabilizer.png';
  import products_slide_3 from './styling/images/home/products_slides/product3_linecoditioner.png';
  import products_slide_4 from './styling/images/home/products_slides/product4_solar.png';
  import products_slide_5 from './styling/images/home/products_slides/product5_manualregulator.png';
  import products_slide_6 from './styling/images/home/products_slides/product6_battery.png';
  import products_slide_7 from './styling/images/home/products_slides/product7_transformer.png';


// services slide images

import services_slide_1 from './styling/images/home/services_slides/1.jpg';
import services_slide_2 from './styling/images/home/services_slides/2.jpg';
import services_slide_3 from './styling/images/home/services_slides/3.jpg';
import services_slide_4 from './styling/images/home/services_slides/4.jpg';
import services_slide_5 from './styling/images/home/services_slides/5.jpg';
import services_slide_6 from './styling/images/home/services_slides/6.jpg';


// applications slide images

import applications_slide_1 from './styling/images/home/applications_slides/1.png';
import applications_slide_2 from './styling/images/home/applications_slides/2.png';
import applications_slide_3 from './styling/images/home/applications_slides/3.png';
import applications_slide_4 from './styling/images/home/applications_slides/4.png';
import applications_slide_5 from './styling/images/home/applications_slides/5.png';
import applications_slide_6 from './styling/images/home/applications_slides/6.png';
import applications_slide_7 from './styling/images/home/applications_slides/7.png';


// clients slide images

import clients_slide_1 from './styling/images/home/clients_slides/1.jpg';
import clients_slide_2 from './styling/images/home/clients_slides/2.png';
import clients_slide_3 from './styling/images/home/clients_slides/3.png';
import clients_slide_4 from './styling/images/home/clients_slides/4.png';
import clients_slide_5 from './styling/images/home/clients_slides/5.png';
import clients_slide_6 from './styling/images/home/clients_slides/6.png';
import clients_slide_7 from './styling/images/home/clients_slides/7.png';
import clients_slide_8 from './styling/images/home/clients_slides/8.jpg';
import clients_slide_9 from './styling/images/home/clients_slides/9.png';



  const Home = () => {
    const [slideIndex, setSlideIndex] = useState(0);

    useEffect(() => {
      const interval = setInterval(() => {
        setSlideIndex((prevIndex) => (prevIndex + 1) % slides.length);
        
      }, 6000);

      return () => clearInterval(interval);
    }, []);

    const slides = [
      { image: slider1_1, head: "AROSE POWER TECHNOLOGIES" , headimage: head_img1,
        smallImages: [smallimg1_1, smallimg1_2, smallimg1_3, smallimg1_4, smallimg1_5, smallimg1_6],
        captions : ["Power Factor 1.0", "Pure Sine Wave Output", "SNMP Communication", "Smart LED Display", "Fast Response", "High Protection"] },
      { image: slider1_2, head: "AROSE POWER TECHNOLOGIES" , headimage: head_img2,
        smallImages: [smallimg2_1, smallimg2_2, smallimg2_3, smallimg2_4, smallimg2_5, smallimg2_6],
        captions : ["Wide Input Voltage Range", "Stable & Noise Free Output", "Servo Motor Control System", "Smart LED Display", "Fast Response", "High Protection"]  },
      { image: slider1_3, head: "AROSE POWER TECHNOLOGIES" , headimage: head_img1,
        smallImages: [smallimg1_1, smallimg1_2, smallimg1_3, smallimg1_4, smallimg1_5, smallimg1_6],
        captions : ["Power Factor 1.0", "Pure Sine Wave Output", "SNMP Communication", "Smart LED Display", "Fast Response", "High Protection"] },
      { image: slider1_4, head: "AROSE POWER TECHNOLOGIES" , headimage: head_img3,
        smallImages: [smallimg4_1, smallimg4_2, smallimg4_3, smallimg4_4, smallimg4_5, smallimg4_6],
        captions : ["Zero Output Distortion", "Ideal & Reliable Solution", "Maximum Protection", "Spike Absorption", "HassleFree Functioning", "Smooth & Steady Power Supply"] },
        { image: slider1_5, head: "AROSE POWER TECHNOLOGIES" , headimage: head_img4,
          smallImages: [smallimg5_1, smallimg5_2, smallimg5_3, smallimg5_4, smallimg5_5, smallimg5_6],
          captions : ["Line Interactive", "Builtin AVR", "Wide Input Voltage Range", "Smart LED Display", "Fast Response", "High Protection"] }  
    ];

    const plusSlides = (n) => {
      // setSlideIndex((prevIndex) => (prevIndex + n) % slides.length);
      setSlideIndex((prevIndex) => (prevIndex + n + slides.length) % slides.length);
    };


    // ----------------------------------------------------------- section3
    const sliderRef = useRef();

    const products_prev = () => {
      sliderRef.current.slickPrev();
      sliderRef.current.slickPlay();
    };
  
    const products_next = () => {
      sliderRef.current.slickNext();
      sliderRef.current.slickPlay();
    };

      const products_slider = {
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
      };


  const navigate = useNavigate();

  const handleSlideClick = (subpageUrl) => {
    navigate(subpageUrl);
  };

    
    const products_slide = [
      { image: products_slide_1,  caption: "UPS", subpageUrl: '/product_items/Ups'},
      { image: products_slide_2,   caption: "STABILIZER", subpageUrl: '/product_items/Stabilizer'},
      { image: products_slide_3,   caption: "LINE CONDITIONER", subpageUrl: '/product_items/LineConditioner'},
      { image: products_slide_4, caption: "SOLAR", subpageUrl: '/product_items/Solar'},
      { image: products_slide_5,   caption: "MANUAL REGULATOR", subpageUrl: '/product_items/ManualRegulator'},
      { image: products_slide_6,   caption: "BATTERY", subpageUrl: '/product_items/Battery'},
      { image: products_slide_7,   caption: "TRANSFORMER", subpageUrl: '/product_items/Transformer'}
    ];

    // ----------------------------------------------------------- section4
    const services = [
      {
        title: 'Site Survey',
        description: 'We precisely assess, inspect, & suggest the ideal solution that perfectly matches your requirement.',
        imageUrl: services_slide_1
      },
      {
        title: 'Sales & Support',
        description: 'We deliver best quality units in most competitive price with 24/7 on-call support & on-demand site care.',
        imageUrl: services_slide_2
      },
      {
        title: 'Installation Services',
        description: 'We offer expert technical support and provide hassle-free installation within and outside the city.',
        imageUrl: services_slide_3
      },
      {
        title: 'Repairing Services',
        description: 'With our experienced tech team, we solve customers worries by providing repairing both in-store and on-site.',
        imageUrl: services_slide_4
      },
      {
        title: 'Service Contracts',
        description: 'Clients trust & satisfaction is what we aim for thats why we go beyond sales & propose yearly service contract.',
        imageUrl: services_slide_5
      },
      {
        title: 'Digitalization & Automation',
        description: 'Evolving beyond: Smart Automation, App Control, Cloud Access, Data Logs & Prediction.',
        imageUrl: services_slide_6
      }
    ];
  
    const ServiceCard = ({ title, description, imageUrl }) => {
      return (
        <div className="service-card">
          <img src={imageUrl} alt={title} className="service-card-image" />
          <div className="services-content">
          <h3 className="service-card-title">{title}</h3>
          <p className="service-card-description">{description}</p>
          </div>
        </div>
      );
    };
  

    // ----------------------------------------------------------- section5

    const applications = [
      { src: applications_slide_1, title: 'Telecommunications' },
      { src: applications_slide_2, title: 'Industries' },
      { src: applications_slide_3, title: 'Offices' },
      { src: applications_slide_4, title: 'Banks' },
      { src: applications_slide_5, title: 'Hospitals' },
      { src: applications_slide_6, title: 'Networks' },
      { src: applications_slide_7, title: 'Institutes' }
    ];

      // ----------------------------------------------------------- section6

    const clients_slide = [
      { image: clients_slide_1},
      {image: clients_slide_2},
      { image: clients_slide_3},
      {image: clients_slide_4},
      { image: clients_slide_5},
      {image: clients_slide_6},
      {image: clients_slide_7},
      {image: clients_slide_8},
      {image: clients_slide_9}
      ];

        

    return (
      <div className='home'>
        <div className="section1">
        {slides.map((slide, index) => (
  <div className={`slide ${slideIndex === index ? 'active' : ''}`} key={index}>
    <img className="background-image" src={slide.image} alt={`Image ${index + 1}`} />
    <div className="text-head">{slide.head}</div>
    <img className="side-image" src={slide.headimage} alt={`Image ${index + 1}`} />
    <div className="small-images">
    <div className="row">
            {slide.smallImages.slice(0, 3).map((smallImg, idx) => (
              <div key={idx} className="circle-image">
                <img src={smallImg} alt={`Small Image ${idx + 1}`} />
                <div className="caption">{slide.captions[idx]}</div>
              </div>
            ))}
          </div>
          <div className="row">
            {slide.smallImages.slice(3, 6).map((smallImg, idx) => (
              <div key={idx + 3} className="circle-image">
                <img src={smallImg} alt={`Small Image ${idx + 4}`} />
                <div className="caption">{slide.captions[idx + 3]}</div>
              </div>
            ))}
          </div>
    </div>
  </div>
))}


        <button className="prev" onClick={() => plusSlides(-1)}>&#10094;</button>
        <button className="next" onClick={() => plusSlides(1)}>&#10095;</button>
      </div>

      <div className='section2'>
        <h1>WELCOME TO AROSE POWER TECHNOLOGIES</h1>
        <div className='row'>
        <div className='col image'><img src={logo} alt='logo'/></div>
        <div className='col text'>Welcome to Arose Power Technologies ! Since 1990, Arose has been a trusted name in electrical power solutions. Our product lineup includes complete range of UPS, Inverters, Automatic Voltage Stabilizers, Line Conditioners, and Complete Solar Power Solution. Trusted by government and private sectors alike, we deliver unbeatable quality and exceptional service. We pride ourselves on delivering top-notch sales and repair, ensuring our customers receive the best after-sales support. At Arose, client’s satisfaction is our success. Join the countless satisfied customers who have experienced the reliability and superior service. Explore our offerings today and power your future with us !</div>
        </div>
      </div>

          <div className="section3">
        <h1>OUR PRODUCTS</h1>
        <div className="slider-container">
        <Slider  ref={sliderRef} {...products_slider}>
          
        {products_slide.map((products_slide, index) => (
       
        <div
          
          key={index}
          onClick={() => handleSlideClick(products_slide.subpageUrl)} // Handle slide click
        >
            <img 
            src={ products_slide.image}
            alt={`Image ${index + 1}`}
            style={{cursor:"pointer"}}
          />
            <div className='product_caption'>{products_slide.caption}</div>
          </div>
        ))}

      </Slider>
      <div>
        <button className='products_prev' onClick={products_prev}>&#10094;</button>
        <button className='products_next'  onClick={products_next}>&#10095;</button>
      </div>
      </div>
          </div>
        
{/* section4 */}
<div className="section4">
      <h1>OUR SERVICES</h1>
      <div className="services-grid">
        {services.map((service, index) => (
          <ServiceCard
            key={index}
            title={service.title}
            description={service.description}
            imageUrl={service.imageUrl}
          />
        ))}
      </div>
    </div>

{/* section5 */}
<div className="section5">
<h1>OUR APPLICATIONS</h1>
        <div className='applications-grid'>
      {applications.map((image, index) => (
        <div key={index} className="image-card">
          <img src={image.src} alt={image.title} className="image" />
          <p className="image-title">{image.title}</p>
        </div>
      ))}
      </div>
    </div>

{/* section6 */}
<div className="section6">
<h1>OUR CLIENTS</h1>
          <HomepgSliders slides={clients_slide}/>
          </div>
      </div>

    
      
    );
    
  };

  export default Home;
